import { render, staticRenderFns } from "./perseo_menu_mantenimiento.vue?vue&type=template&id=58510ae6&scoped=true"
import script from "./perseo_menu_mantenimiento.vue?vue&type=script&lang=js"
export * from "./perseo_menu_mantenimiento.vue?vue&type=script&lang=js"
import style0 from "./perseo_menu_mantenimiento.vue?vue&type=style&index=0&id=58510ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58510ae6",
  null
  
)

export default component.exports